import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { TenantService } from './tenant.service';
import { SqManagementAuthentifikation, SqManagementAuthentifikationReq } from '../models/SquirrelManagement';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SquirrelManagementService {

  constructor(
    private httpClient: HttpClient,
    private tenantService: TenantService
    )
  {
  }


  GetSq3ProjectAuthentification(tenant: string, projectId: string) : Observable<SqManagementAuthentifikation> {
    var self = this;
    return new Observable<SqManagementAuthentifikation>((subscriber)=>{
      self.tenantService.getToken(tenant, true, projectId).subscribe({
        next: (appToken) => {
          const headers = new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/json');

          let jsonReq = '{'+'"applicationtoken":"'
            +appToken
            +'"}';
          console.log("-------> GetSq3ProjectAuthentification, jsonReq = ", jsonReq)

          self.httpClient.post<SqManagementAuthentifikation>(`https://squirrelmanagementapi-2346weg2erhsdghewww.albert-ing.com/api/SQ3Authentication/addAuthentication`, jsonReq, { headers: headers }).subscribe ({
            next:(projectAuth) => {
              subscriber.next(projectAuth);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }
  GetSq3ProjectAuthentificationId(tenant: string, projectId: string) : Observable<string> {
    var self = this;
    return new Observable<string>((subscriber)=>{
     self.tenantService.createApplicationTokenId(tenant, projectId).subscribe({
        // self.tenantService.createApplicationToken(tenant, projectId).subscribe({
          next: (appTokenId) => {
              subscriber.next(appTokenId);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          // const headers = new HttpHeaders()
          // .set('Content-Type', 'application/json')
          // .set('Accept', 'application/json');

          // let jsonReq = '{'+'"applicationtokenId":"'
          //   +appTokenId
          //   +'"}';
          // console.log("-------> GetSq3ProjectAuthentificationId, jsonReq = ", jsonReq)

          // self.httpClient.post<SqManagementAuthentifikation>(`https://squirrelmanagementapi-2346weg2erhsdghewww.albert-ing.com/api/SQ3Authentication/addAuthentication`, jsonReq, { headers: headers }).subscribe ({
          //   next:(projectAuth) => {
          //     subscriber.next(projectAuth);
          //   },
          //   complete:() => {
          //     subscriber.complete();
          //   },
          //   error: (error: any) => {
          //     subscriber.error(error);
          //   }
        })
      });
    }
  }

